module.exports = __webpack_public_path__ + "img/gzh2.a104df90.png";